import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LegacyComponentsModule } from '@coin/shared/core/feature-legacy-components';
import { AppEnvironment, CustomTranslationLoader } from '@coin/shared/core/data-access-translation-loader';
import { V2ButtonComponent, V2DialogModule } from '@coin/shared/core/ui-storybook';
import { TranslateModule } from '@ngx-translate/core';
import { SimplebarAngularModule } from 'simplebar-angular';
import { SharedModule } from '../shared/shared.module';
import { EquityLegalDisclaimerComponent } from './dialogs/equity-legal-disclaimer/equity-legal-disclaimer.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MatIconModule,
    TranslateModule.forChild(CustomTranslationLoader.createConfig(AppEnvironment.Customer)),
    MatSlideToggleModule,
    FormsModule,
    SimplebarAngularModule,
    LegacyComponentsModule,
    V2ButtonComponent,
    V2DialogModule,
    EquityLegalDisclaimerComponent
  ]
})
export class EquityModule {}
